import axios from 'axios';

export default function LoadLocalization(setLangCallback) {
    const langs = ['en', 'ge', 'du', 'sp', 'it', 'ch', 'tu', 'fr', 'ru'];
    try {
        var lang = HC_GetCookie('hc_lang');
    } catch (error) {}

    if (langs.indexOf(lang) < 0)
        lang = 'en';
    window.HC_LANG = {};
    HC_ChangeLanguage(lang, setLangCallback);
}
window.HC_ChangeLanguage = function(lang, setLangCallback = null) {
    window.HC_CURRENT_LANGUAGE = lang;
    window.HC_LANG = {};
    try {
        HC_SetCookie('hc_lang', window.HC_CURRENT_LANGUAGE);
    } catch (error) {}

    if (window.cordova) {
        window.HC_LANG = window.HC_PHONEGAP_LANGS[lang];
        if (setLangCallback)
            setLangCallback();
        else
            HC_History.replace(location.pathname);
    }
     else {
        let requestUrl = '/public/js/locale/' + lang + '.js';
        axios.get(requestUrl)
            .then(function (response) {
                window.HC_LANG = response.data;
                if (setLangCallback)
                    setLangCallback();
                else
                    HC_History.replace(location.pathname);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
};




// WEBPACK FOOTER //
// ./localization.js